
export class InvalidChangeAddress {
  public readonly key = 'InvalidChangeAddress';

  constructor(
    public readonly address: string,
    public readonly address2: string,
    public readonly city: string,
    public readonly state: string,
    public readonly zip: string
  ) {}
}

export class ValidChangeAddress {
  public static create(
    address: string,
    address2: string,
    city: string,
    state: string,
    zip: string,
    
  ) {
    if(address?.length>0&&(zip?.length>0||(city.length>0&&state.length>0)))
    {    
    return new ValidChangeAddress(address,address2, city, state, zip);
    }
    else{
      return new InvalidChangeAddress( address,address2, city, state, zip);
    }

  }

  public readonly key = 'ValidChangeAddress';

  private constructor(
    public readonly address: string,
    public readonly address2: string,
    public readonly city: string,
    public readonly state: string,
    public readonly zip: string,
   
  ) {}
}

export type AddressChangeRequest = ValidChangeAddress | InvalidChangeAddress;

export const EmptyChangeAddressRequest = new InvalidChangeAddress(
  "",
  "",
  "",
  "",
  "",
);


export const isValidAddressChangeRequest = (
  addressChangeRequest: AddressChangeRequest
): addressChangeRequest is ValidChangeAddress => addressChangeRequest.key === 'ValidChangeAddress';
